import {useParams, useRouteMatch} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Box, Stack} from '@mui/material';
import GenericHeader from '../../../../../../../components/generic-header/generic-header';
import {translations} from '../../../../../../../i18n/translations';
import {LocalStorageKey, ScreenPaths} from '../../../../../../../enums';
import {useSeniorSidebar} from '../../../../../../../contexts/seniors-sidebar/context';
import {SeniorHealthCharts} from './senior-health-charts/senior-health-charts';
import {DateRangeInput} from '../../../../../../../components/date-range-input/date-range-input';
import {useState} from 'react';
import {Moment} from 'moment';
import {
  DateRangeType,
  calcEndDateByRange,
  calcStartDateByRange,
} from '../../../../../../../components/date-range-input/date-range-utils';

export default function SeniorStatisticsHealthProfessionalCaregiverOfficeScreen() {
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  const {t} = useTranslation();
  const {url} = useRouteMatch();
  const seniorSidebarCtx = useSeniorSidebar();
  const [startDate, setStartDate] = useState(getInitialStartDate);
  const [endDate, setEndDate] = useState(getInitialEndDate);

  const user = seniorSidebarCtx.state.senior?.originalData;
  const dashboardLink = `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_Dashboard}`;

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: '14px', width: '100%'}}>
      <GenericHeader
        titleCrumbs={[
          {
            label: t(translations.office.professional_caregiver.tabs.seniors),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
          },
          {
            label: user?.displayName || user?.name,
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
          },
          {label: t(translations.screen_paths.senior_dashboard), link: dashboardLink},
          {label: t(translations.seniorSideMenu.healthStatistics), link: url},
        ]}
        isLoading={user === undefined}
        leftColumn={<></>}
        rightColumn={
          <Stack direction="row" justifyContent="flex-end" alignItems="center">
            <DateRangeInput
              startDate={startDate}
              endDate={endDate}
              onChange={(startDate, endDate, range) => {
                setStartDate(startDate);
                setEndDate(endDate);
                if (range !== 'custom')
                  localStorage.setItem(LocalStorageKey.HealthChartsRange, range);
              }}
            />
          </Stack>
        }
      />

      {id && <SeniorHealthCharts userId={id} startDate={startDate} endDate={endDate} />}
    </Box>
  );
}

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------

function getInitialStartDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.HealthChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcStartDateByRange(storedRange ?? '7d');
}

function getInitialEndDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.HealthChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcEndDateByRange(storedRange ?? '7d');
}
